import {Card,CardBody, Row, Col, Button} from 'reactstrap'
import React, {useEffect} from 'react'
import reqwest from 'reqwest'
export default function AllClearComponent({goodbyeText, accentColor, secondaryColor, setStep, phoneNumber, date, phoneField, dateField, campaignId, apiAddress}){
    
    useEffect(() => {
        reqwest({
            url: apiAddress,
            method: 'post',
            type: 'xml',
            crossOrigin: true,
            data: { wsName: 'wsImportRecord', ...{
                'CampaignId': campaignId,
                'PhoneField': phoneField,
                'PhoneNumber': phoneNumber,
                'PhoneCallDateField': dateField,
                'PhoneCallDate': date
            }}
        })
    }, [])
    
    return(
        <Card>
            <CardBody>
                <div className="centered-div big-text">
                    {goodbyeText}
                </div>
                <Row className="button-strip">
                    <Col>
                        <Button onClick={() => setStep("close")} style={{backgroundColor: accentColor, color: secondaryColor}} className="mr-2">Ok</Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}